import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=19fb1e8e"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=19fb1e8e&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports